import { render, staticRenderFns } from "./TenderContractors.vue?vue&type=template&id=31d62fa7&"
import script from "./TenderContractors.vue?vue&type=script&lang=js&"
export * from "./TenderContractors.vue?vue&type=script&lang=js&"
import style0 from "./TenderContractors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports